import * as React from 'react';
import Card from 'src/core/ui/card';
import { ImageUpload } from 'src/core/ui/upload';
import Switch from '../../../core/ui/switch';
import Grid from 'src/core/ui/grid';
import Divider from 'src/core/ui/divider';
import { Col } from '../../../core/ui/grid';
import TextArea from 'src/core/ui/textarea';
import FormInput from 'src/core/ui/input';
import { IProcessModule } from "../../../typings";

export interface ArtProcessProps {
    model: IProcessModule;
    onChange: (data: IProcessModule) => void;
}

export interface ArtProcessState {
}

export default class ArtProcess extends React.Component<ArtProcessProps, ArtProcessState> {
  constructor(props: ArtProcessProps) {
    super(props);

    this.state = {
    }
  }

  handleChange = (id: keyof IProcessModule, value: any) => {
    this.props.model[id] = value;
    this.props.onChange({...this.props.model});
  }
  public render() {
      const item = this.props.model;

    return (
        <Card
        header={<div className='card-header-switch'><h2 className='card-header-text'>Process module </h2> 
            <Switch label='Visible' 
            onChange={e => this.handleChange('visible', e)}
    checked={item.visible} /></div>}>
        <Grid centered>

            <Col size={50}>
                <div className='module-description'>
                    <h3>Description</h3>
                    <Divider/>
                    <TextArea
                        value={item.description}
                        onChange={e => this.handleChange('description', e)}
                    />
                </div>
                <div className='module-description'>
                    
                    <FormInput
                        label='Insert link to youtube or vimeo'
                        position='top'
                        value={item.video_link}
                        onChange={e => this.handleChange('video_link', e)}
                        placeholder='Video URL'
                        style='dark'
                    />
                </div>
                
                <div className='module-description'>
                    <h3>Add Quote</h3>
                    <Divider/>
                    <TextArea
                        value={item.quote}
                        onChange={e => this.handleChange('quote', e)}
                    />
                </div>
            </Col>
            <Col size={50}>
                <h4 className="header-4">Image gallery</h4>
                <label style={{maxWidth: '60px', marginBottom:'20px'}}>Add up to 6 images (JPEG, JPG, PNG)  of your Art work.</label>
                <br/>
                <label>Maximum file size 30MB</label>
                <div className='upload-container'>
                <Grid centered>
                    <Col size={40}>
                        <ImageUpload 
                            minified
                            value={item.image1}
                            onDelete={() => this.handleChange('image1', null)}
                            onUpload={e => {
                                this.handleChange('image1', e.id)
                            }}
                            />
                        <FormInput
                            position='top'
                            label='Image title 1'
                            placeholder='Ej. Sketching Ideas'
                            value={item.title1}
                            onChange={e => this.handleChange('title1', e)}
                        />
                    </Col>
                    <Col size={1}></Col>
                    <Col size={59}>
                        <ImageUpload 
                            minified
                            value={item.image2}
                            onDelete={() => this.handleChange('image2', null)}
                            onUpload={e => {
                                this.handleChange('image2', e.id)
                            }}
                        />
                        <FormInput
                            position='top'
                            label='Image title 2'
                            value={item.title2}
                            onChange={e => this.handleChange('title2', e)}
                            placeholder='Ej. Sketching Ideas'
                        />
                    </Col>
                </Grid>

                <Grid centered>
                    <Col size={40}>
                    <ImageUpload 
                            minified
                            value={item.image3}
                            onDelete={() => this.handleChange('image3', null)}
                            onUpload={e => {
                                this.handleChange('image3', e.id)
                            }}
                        />

                        <FormInput
                            position='top'
                            label='Image title 3'
                            value={item.title3}
                            onChange={e => this.handleChange('title3', e)}
                            placeholder='Ej. Sketching Ideas'
                        />
                    </Col>
                    <Col size={1}></Col>
                    <Col size={59}>
                        <ImageUpload 
                            minified
                            value={item.image4}
                            onDelete={() => this.handleChange('image4', null)}
                            onUpload={e => {
                                this.handleChange('image4', e.id)
                            }}
                        />
                        <FormInput
                            position='top'
                            label='Image title 4'
                            value={item.title4}
                            onChange={e => this.handleChange('title4', e)}
                            placeholder='Ej. Sketching Ideas'
                        />
                    </Col>
                </Grid>

                <Grid centered>
                    <Col size={40}>
                        <ImageUpload 
                            minified
                            value={item.image5}
                            onDelete={() => this.handleChange('image5', null)}
                            onUpload={e => {
                                this.handleChange('image5', e.id)
                            }}
                        />
                        <FormInput
                            position='top'
                            label='Image title 5'
                            value={item.title5}
                            onChange={e => this.handleChange('title5', e)}
                            placeholder='Ej. Sketching Ideas'
                        />
                    </Col>
                    <Col size={1}></Col>
                    <Col size={59}>
                        <ImageUpload 
                            minified
                            value={item.image6}
                            onDelete={() => this.handleChange('image6', null)}
                            onUpload={e => {
                                this.handleChange('image6', e.id)
                            }}
                        /><FormInput
                            position='top'
                            label='Image title 6'
                            value={item.title6}
                            onChange={e => this.handleChange('title6', e)}
                            placeholder='Ej. Sketching Ideas'
                        />
                    </Col>
                </Grid>

                </div>
            </Col>
        </Grid>
    </Card>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/arts/parts/art-process.tsx